import { SESSIONS_STORAGE_ITEMS } from "@config";
import { aPIPaths, handleResponse, methods, requestJSON } from "../../Config";

function assignSessionUserTokenToHeader(APICall) {
  function wrappedFunction() {
    const sessionUser = sessionStorage.getItem(SESSIONS_STORAGE_ITEMS.USER);
    if (sessionUser) {
      const token = JSON.parse(sessionUser)?.token;
      requestJSON.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return APICall(...arguments);
  }
  return wrappedFunction;
}

const getFormDraft = assignSessionUserTokenToHeader(async () => {
  const response = await requestJSON(aPIPaths.getApplicationDraft, {
    method: methods.get
  });
  return handleResponse(response);
});

const saveFormDraft = assignSessionUserTokenToHeader(async data => {
  const response = await requestJSON(aPIPaths.postSaveApplicationDraft, {
    method: methods.post,
    data
  });
  return handleResponse(response);
});

export const StepperFormService = {
  getFormDraft,
  saveFormDraft
};
